import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function getSelectedGCals(
  onBehalfOf?: string,
): Promise<CalendarEntry[]> {
  const res = await fetchOrchidAPI(
    `/api/scheduler_calendar_integrations/user_calendars${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res.json();
}
